<nz-layout class="care-plan-section">
  <nz-header> </nz-header>
  <nz-content>
    <app-care-plan />
    <app-care-plan-file />
  </nz-content>
</nz-layout>
